<template>
  <div id="user-list">
    <v-container>
      <v-card>
        <v-card-text>
          <div class="headline">ユーザー一覧</div>
          <v-btn color="success" class="my-3" @click="modal = true"
            >新規ユーザーの作成</v-btn
          >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ユーザーネーム</th>
                  <th>所属グループ</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in userList" :key="item.id">
                  <td>{{ item.username }}</td>
                  <td>{{ item.site_group ? item.site_group.name : "" }}</td>
                  <td>
                    <v-btn @click="openEditModal(item)" class="mr-3"
                      >設定</v-btn
                    >
                    <v-btn
                      @click="
                        selectedUser = item;
                        confirmUserDelete = true;
                      "
                      color="error"
                      >削除</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>

    <user-create-modal
      :modal="modal"
      @close="modal = false"
      @submit="createUser"
    ></user-create-modal>

    <user-edit-modal
      :modal="editModal"
      :user="editedUser"
      @close="
        editModal = false;
        editedUser = null;
      "
      :groupOption="groupList"
      @submit="updateEditedUser($event)"
    />

    <v-dialog v-model="confirmUserDelete" max-width="400">
      <DeleteConfirmation
        title="ユーザーアカウントの削除"
        @confirm="
          deleteUser(selectedUser.id);
          confirmUserDelete = false;
        "
        @close="
          selectedUser = null;
          confirmUserDelete = false;
        "
        >ユーザー
        {{
          selectedUser ? selectedUser.username : ""
        }}
        を削除します。</DeleteConfirmation
      >
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api";
import User from "@/models/user";
import UserCreateModal from "@/components/UserCreateModal";
import UserEditModal from "@/components/UserEditModal";
import DeleteConfirmation from "@/components/DeleteConfirmation";

export default {
  name: "UserList",
  components: { UserCreateModal, UserEditModal, DeleteConfirmation },
  data() {
    return {
      modal: false,
      editModal: false,
      editedUser: null,
      selectedUser: null,
      confirmUserDelete: false,
    };
  },
  computed: {
    userList() {
      return this.$store
        .$db()
        .model("users")
        .query()
        .withAll()
        .where("role", (value) => value == "general")
        .get();
    },
    groupList() {
      return this.$store
        .$db()
        .model("site_groups")
        .query()
        .get();
    },
  },
  methods: {
    createUser(form) {
      const params = {
        user: {
          username: form.username,
          password: form.password,
        },
        site_group: { name: form.site_group },
      };

      api.users.create(params).then((data) => User.insert({ data }));
      this.modal = false;
    },
    deleteUser(userId) {
      api.users.delete(userId).then(() => User.delete(userId));
    },
    openEditModal(user) {
      this.editedUser = user;
      this.editModal = true;
    },
    updateEditedUser(event) {
      if (event === null) return;

      const params = {
        id: this.editedUser.id,
        site_group: { id: event.id, name: event.name },
      };
      api.users.update(params).then((data) => User.insert({ data }));
      this.editedUser = null;
      this.editModal = false;
    },
  },
};
</script>

<style></style>
